module.exports = __webpack_public_path__ + "static/share-be57ad4449420e06d74f03dbe6a120da.png";